import { Link } from "react-router-dom";
import { bigEvents } from "@/mocks/home";

export default function BigTimeline() {
  return (
    <section id="timeline" className="w-full bg-background-50 scroll-mt-20">
      <div className="max-w-content mx-auto w-full px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 md:mb-12">
          <div>
            <span className="text-xs md:text-sm font-medium text-primary-600 tracking-wide">
              TIMELINE / 大事件时间线
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              最近都发生了些什么
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            按日期倒序排列的关键节点，点开任意一条即可进入对应话题合集，看完整来龙去脉。
          </p>
        </div>

        <div className="relative pl-6 md:pl-8">
          <div className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-px bg-background-300"></div>
          <ul className="space-y-6 md:space-y-7">
            {bigEvents.map((e, i) => (
              <li key={e.date + e.title} className="relative">
                <span
                  className={`absolute -left-6 md:-left-8 top-1.5 w-3.5 h-3.5 rounded-full border-2 ${
                    i === 0
                      ? "bg-accent-500 border-accent-500"
                      : "bg-background-50 border-secondary-400"
                  }`}
                ></span>
                <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-5">
                  <span className="font-heading text-lg md:text-xl font-bold text-foreground-900 w-24 shrink-0">
                    {e.month}
                  </span>
                  <div className="flex-1">
                    <Link
                      to="/collections"
                      className="text-sm md:text-base text-foreground-800 hover:text-primary-600 transition-colors"
                    >
                      {e.title}
                    </Link>
                  </div>
                  <span className="shrink-0 self-start md:self-center px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-800 text-xs">
                    {e.category}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
          <Link
            to="/collections"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-list-check-2"></i>
            浏览全部合集
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            了解整理方式
          </Link>
        </div>
      </div>
    </section>
  );
}